/** @jsxImportSource react */
import { createContext, useCallback, useContext, useState } from 'react'
import { Alert, Snackbar } from '@mui/material'

const NotificationContext = createContext(() => {})

/** notify('Saved') or notify('Failed', 'error') */
export const useNotify = () => useContext(NotificationContext)

const NotificationProvider = ({ children }) => {
  const [message, setMessage] = useState(null)

  const notify = useCallback((text, severity = 'success') => {
    setMessage({ text, severity, key: Date.now() })
  }, [])

  return (
    <NotificationContext.Provider value={notify}>
      {children}
      <Snackbar
        key={message?.key}
        open={!!message}
        autoHideDuration={message?.severity === 'error' ? 6000 : 3000}
        onClose={(_, reason) => reason !== 'clickaway' && setMessage(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        {message ? (
          <Alert severity={message.severity} variant="filled" onClose={() => setMessage(null)}>
            {message.text}
          </Alert>
        ) : undefined}
      </Snackbar>
    </NotificationContext.Provider>
  )
}

export default NotificationProvider
